import Node from './Node';

export default class Mention extends Node {
  constructor(mention) {
    super();
    this.mention = mention;
  }

  finalize(root, parent) {
    super.finalize(root, parent);
    this.root.emojiOnly = false;
  }

  toJSON() {
    return this.mention;
  }

  toSource() {
    return this.mention.text;
  }
}
